import BaseAngleManager from "../../../../../src/managers/BaseAngleManager";
import { AngleProps, Coord } from "../../../../../src/types/Interface";
import { PINK_ANGLE_COLORS } from "../types/Config";

const pAC = PINK_ANGLE_COLORS;


export default class AngleManager extends BaseAngleManager {
    private cCoord: Coord;
    constructor(cCoord: Coord) {
        const anglePropsArr: AngleProps[] = Array(1)
            .fill(null)
            .map((_, i) => ({ angleColors: { color: pAC[0], textColor: pAC[1] }, smallDistanceOffset: 20, addSmallDis: false }))
        super(anglePropsArr)
        this.cCoord = cCoord;
    }
    
    draw(chordPoints: Coord[], clockwise: boolean = true) {
        const Points = { curr: chordPoints[1], prev: this.cCoord, next: chordPoints[0] };
        const degree = 90;
        this.drawAngle(this.Angles[0], Points, degree, clockwise)
    }
}